export const orderStage = {
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  REFUNDING: 'REFUNDING',
  WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
  WAITING_FOR_CHECK_IN: 'WAITING_FOR_CHECK_IN',
  CHECKED_IN: 'CHECKED_IN',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
};

export const BookingJourney = {
  FULL_AUTOMATIC: 'FULL_AUTOMATIC',
  MANUAL: 'MANUAL',
  SEMI_AUTOMATIC: 'SEMI_AUTOMATIC',
  INSTANT_BOOK: 'INSTANT_BOOK',
};

export const INSTANT_BOOKING_STEP = {
  FILLING_PERSONAL_INFO: 'FILLING_PERSONAL_INFO',
  SIGNING_AGREEMENT: 'SIGNING_AGREEMENT',
  MAKING_PAYMENT: 'MAKING_PAYMENT',
};

export const INSTANT_BOOKING_STATUS = {
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  COMPLETED: 'COMPLETED',
  CHECKED_IN: 'CHECKED_IN',
  CANCELLED: 'CANCELLED',
  LOST: 'LOST',
};
